import script from "./ATT04_004RPT.vue?vue&type=script&setup=true&lang=js"
export * from "./ATT04_004RPT.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__